import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
	accessibilitySelector: undefined, // either 'navigation' or 'hotspot'
	activeNavIndex: undefined,
	navMarkerCount: 0,
	activeHotspotIndex: undefined,
	hotspotMarkerCount: 0,
	accessibilityControlsEnabled: true,
	navMarkers: [],
	hotspots: [],
	activeHotspotId: null,
};

const accessibilityReducer = createSlice({
	name: 'accessibility',
	initialState,
	reducers: {
		setAccessibilitySelector: (state, action) => {
			const { payload } = action;
			state.accessibilitySelector = payload;
		},
		setActiveNavIndex: (state, action) => {
			const { payload } = action;
			state.activeNavIndex = payload;
		},
		setNavMarkerCount: (state, action) => {
			const { payload } = action;
			state.navMarkerCount = payload;
		},
		setActiveHotspotIndex: (state, action) => {
			const { payload } = action;
			state.activeHotspotIndex = payload;
		},
		setHotspotMarkerCount: (state, action) => {
			const { payload } = action;
			state.hotspotMarkerCount = payload;
		},
		setAccessibilityControls: (state, action) => {
			const { payload } = action;
			state.accessibilityControlsEnabled = payload;
		},
		setNavMarkers: (state, action) => {
			const { payload } = action;
			state.navMarkers = payload;
		},
		setHotspots: (state, action) => {
			const { payload } = action;
			state.hotspots = payload;
		},
		setActiveHotspotId: (state, action) => {
			const { payload } = action;
			state.activeHotspotId = payload;
		},
	},
});

export const createIsHotspotActiveAdaSelector = (lookupId) =>
	createSelector(
		[(state) => state.accessibility],
		(accessibility) => accessibility.activeHotspotId === lookupId,
	);

export const {
	setAccessibilitySelector,
	setActiveNavIndex,
	setNavMarkerCount,
	setActiveHotspotIndex,
	setHotspotMarkerCount,
	setAccessibilityControls,
	setNavMarkers,
	setHotspots,
	setActiveHotspotId,
} = accessibilityReducer.actions;

export default accessibilityReducer.reducer;
